import firebase from 'firebase';

export const initializeFirebase = () => {
  firebase.initializeApp({
    apiKey: "AIzaSyDiIptJImDMivOcW-3e7ywI8HYrW_Y8Ado",
    authDomain: "trackertartistebe.firebaseapp.com",
    projectId: "trackertartistebe",
    storageBucket: "trackertartistebe.firebasestorage.app",
    messagingSenderId: "970287561073",
    appId: "1:970287561073:web:b50705bace9ad5e1a51ed0"
  });
}

export const askForPermissionToReceiveNotifications = async () => {
    // If running inside the native iOS app, use the native push token
    // injected by AppDelegate instead of requesting a web push token.
    if (window.__nativePushToken) {
        console.info("[Firebase] Using native iOS push token");
        localStorage.setItem("fcm_token", window.__nativePushToken);
        return { status: "SUCCESS", token: window.__nativePushToken };
    }
    if (window.webkit?.messageHandlers?.nativePush) {
        console.info("[Firebase] Native iOS app detected, waiting for token...");
        const token = await new Promise((resolve) => {
            let attempts = 0;
            const check = setInterval(() => {
                if (window.__nativePushToken) {
                    clearInterval(check);
                    resolve(window.__nativePushToken);
                } else if (++attempts >= 50) {
                    clearInterval(check);
                    resolve(localStorage.getItem("fcm_token") || null);
                }
            }, 100);
        });
        if (token) {
            console.info("[Firebase] Got native iOS push token after waiting");
            localStorage.setItem("fcm_token", token);
            return { status: "SUCCESS", token: token };
        }
        console.warn("[Firebase] Native iOS app but no token available");
    }
  try {
    const messaging = firebase.messaging();

    await messaging.requestPermission();
    const token = await messaging.getToken({
      vapidKey: "BEDemfH5riJrjDu9aEIm28IQXj6YhegJvCKa2V5DAqIoeBovV8Gij4kWV2Sg7r4cS5TyHK0KllYRBQ1-b-afM5E"
    });
    return ({
      status: "SUCCESS",
      token: token
    });
  } catch (error) {
    return ({
      status: "FAIL",
      error: error
    });
  }
}
